export default __webpack_public_path__ + "static/media/p2023-41.f7ce7724.jpeg";